import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedName from 'I18n/components/FormattedName';
import AvatarViewer from '../features/avatar/components/AvatarViewer';
import { H1 } from 'foundations-components/transitional/components/H1';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/transitional/components/View';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UserProfile = ({
  avatarHash,
  firstName,
  lastName,
  email
}) => {
  const isMarketingThemeEnabled = getMarketingThemePreference();
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(TFlex, {
    align: isMobile ? 'start' : 'center',
    alignSelf: "stretch",
    direction: isMobile ? 'column' : 'row',
    justify: isMobile ? 'center' : 'start',
    children: [/*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(AvatarViewer, {
        avatarHash: avatarHash,
        borderColor: "border-core-on-fill-default",
        borderStyle: isMarketingThemeEnabled ? undefined : 'solid',
        borderWidth: "200",
        email: email,
        size: "lg"
      })
    }), /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(View, {
        color: isMarketingThemeEnabled ? 'text-core-default' : 'text-core-on-fill-default',
        marginBlockStart: isMobile ? '300' : undefined,
        marginInlineStart: isMobile ? undefined : '500',
        textAlign: isMobile ? 'left' : 'center',
        children: /*#__PURE__*/_jsx(H1, {
          "data-test-id": "user-full-name",
          margin: "0",
          typography: isMobile ? 'heading-500' : 'heading-600',
          children: /*#__PURE__*/_jsx(FormattedName, {
            familyName: lastName,
            givenName: firstName
          })
        })
      })
    })]
  });
};
export default UserProfile;